import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import hcMap from 'highcharts/modules/map';
import mapData from '@highcharts/map-collection/custom/world.geo.json';
hcMap(Highcharts);

const DrillDownChart = (props) => {
    const {} = props;

    const options = {
        chart: {
            map: 'countries/us/us-all',
        },
        title: {
            text: null,
        },
        navigation: {
            buttonOptions: {
                enabled: false,
            },
        },
        credits: {
            enabled: false,
        },
        mapNavigation: {
            enabled: true,
            enableDoubleClickZoomTo: true,
        },
        // colorAxis: {
        //     min: 0,
        //     stops: [
        //         [0, '#EFEFFF'],
        //         [0.5, Highcharts.getOptions().colors[0]],
        //         [
        //             1,
        //             Highcharts.color(Highcharts.getOptions().colors[0])
        //                 .brighten(-0.5)
        //                 .get(),
        //         ],
        //     ],
        // },
        series: [
            {
                name: 'USA',
                data: [
                    {
                        'hc-key': 'us-al',
                        value: 10,
                    },
                    {
                        'hc-key': 'us-ak',
                        value: 20,
                    },
                    {
                        'hc-key': 'us-az',
                        value: 30,
                    },
                    {
                        'hc-key': 'us-ar',
                        value: 40,
                    },
                    {
                        'hc-key': 'us-ca',
                        value: 50,
                    },
                    {
                        'hc-key': 'us-co',
                        value: 60,
                    },
                    {
                        'hc-key': 'us-ct',
                        value: 70,
                    },
                    {
                        'hc-key': 'us-de',
                        value: 80,
                    },
                    {
                        'hc-key': 'us-fl',
                        value: 90,
                    },
                    {
                        'hc-key': 'us-ga',
                        value: 100,
                    },
                    {
                        'hc-key': 'us-hi',
                        value: 110,
                    },
                    {
                        'hc-key': 'us-id',
                        value: 120,
                    },
                    {
                        'hc-key': 'us-il',
                        value: 130,
                    },
                    {
                        'hc-key': 'us-in',
                        value: 140,
                    },
                    {
                        'hc-key': 'us-ia',
                        value: 150,
                    },
                    {
                        'hc-key': 'us-ks',
                        value: 160,
                    },
                    {
                        'hc-key': 'us-ky',
                        value: 170,
                    },
                    {
                        'hc-key': 'us-la',
                        value: 180,
                    },
                    {
                        'hc-key': 'us-me',
                        value: 190,
                    },
                    {
                        'hc-key': 'us-md',
                        value: 200,
                    },
                    {
                        'hc-key': 'us-ma',
                        value: 210,
                    },
                    {
                        'hc-key': 'us-mi',
                        value: 220,
                    },
                    {
                        'hc-key': 'us-mn',
                        value: 230,
                    },
                    {
                        'hc-key': 'us-ms',
                        value: 240,
                    },
                    {
                        'hc-key': 'us-mo',
                        value: 250,
                    },
                    {
                        'hc-key': 'us-mt',
                        value: 260,
                    },
                    {
                        'hc-key': 'us-ne',
                        value: 270,
                    },
                    {
                        'hc-key': 'us-nv',
                        value: 280,
                    },
                    {
                        'hc-key': 'us-nh',
                        value: 290,
                    },
                    {
                        'hc-key': 'us-nj',
                        value: 300,
                    },
                    {
                        'hc-key': 'us-nm',
                        value: 310,
                    },
                    {
                        'hc-key': 'us-ny',
                        value: 320,
                    },
                    {
                        'hc-key': 'us-nc',
                        value: 330,
                    },
                    {
                        'hc-key': 'us-nd',
                        value: 340,
                    },
                    {
                        'hc-key': 'us-oh',
                        value: 350,
                    },
                    {
                        'hc-key': 'us-ok',
                        value: 360,
                    },
                    {
                        'hc-key': 'us-or',
                        value: 370,
                    },
                    {
                        'hc-key': 'us-pa',
                        value: 380,
                    },
                    {
                        'hc-key': 'us-ri',
                        value: 390,
                    },
                ],
            },
        ],
        mapData: Highcharts.maps['countries/us/us-all'],
        joinBy: 'hc-key',
        dataLabels: {
            enabled: true,
            format: '{point.name}',
        },
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default DrillDownChart;
